<script setup lang="ts">
import { computed } from 'vue'
import { useSiteStore } from '../stores/site'

const site = useSiteStore()
const alt = computed(() => `${site.brand.name || site.site?.siteName || '站点'} Logo`)
const name = computed(() => site.brand.name || site.site?.siteName || 'ff-cms')
</script>

<template>
  <span v-if="site.theme.logoMediaId" class="brand-logo brand-logo-image">
    <img :src="`/media/${site.theme.logoMediaId}`" :alt="alt">
  </span>
  <span v-else class="brand-logo brand-logo-fallback">
    <span class="logo-mark"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 4 14h7l-3 8L19 8h-7l3-6Z" /></svg></span>
    <span class="brand-logo-copy"><strong>{{ name }}</strong><small>INNOVATION DESIGN</small></span>
  </span>
</template>
